export const AppInfoMixin = {
  data() {
    return {
      init: 0,
      appInfo: []
    }
  },
  beforeMount() {
    this.initAppInfo()
  },
  methods: {
    async initAppInfo() {
      this.init = 0
      const appResource = process.env.BASE_URL + 'appInfo/globalProps.json?t=' + new Date().getTime()
      this.$http
        .get(appResource)
        .then(res => {
          this.appInfo = res.data.appInfo
          this.init = 1
        })
        .catch(err => {
          this.init = 2
        })
    }
  }
}
